


/* { 
  name: '',
  website: '',
  logo: '',
  score: ,
  columns: ['', 'X', '',  '', '',''],
  description: '',
  socialHandles: [''],
  videos: [],
  longerDescription: '',
}, */

 const developmentAds  = [
      { 
        name: 'Cash Improvement Proposals',
        website: 'gitlab.com/im_uname/cash-improvement-proposals/-/blob/master/CHIPs.md?ref_type=heads',
        logo: 'nologo.png',
        description: 'The CHIPs is the public documentation of a shared ecosystem process to achieve one positive change on the BCH network . ',
        socialHandles: ['t.me/GeneralProtocols','read.cash/@GeneralProtocols/a-focus-on-the-bitcoin-cash-ecosystem-08-chips-f020b9bc','bitcoincashresearch.org/t/chips-a-more-detailed-process-recommendation/309/25'],
        videos: ['https://www.youtube.com/embed/9rB83MocRrQ'],
        longerDescription: 'For a completely decentralized network, such as Bitcoin Cash, having a robust process for upgrading the network is of huge benefit to all stakeholders.',
        tags:[],
      },
      { 
        name: 'Bitcoincash Research',
        website: 'bitcoincashresearch.org/',
        logo: 'bchresearch.png',
        description: 'Vision The Bitcoin Cash ecosystem requires a common space where pioneers, innovators and developers can collaborate productively.',
        socialHandles: [],
        videos: [],
        longerDescription: '',
        tags:[],
      },  
      { 
        name: 'Simple Ledger Protocol',
        website: 'slp.dev/',
        logo: 'slp.png',
        description: 'Simple Ledger Protocol developed ontop of the Bitcoin Cash blockchain. ',
        socialHandles: ['t.me/simpleledger'],
        videos: [],
        longerDescription: '',
        tags:[],
      },
      { 
        name: 'BCH Bliss',
        website: 'www.bliss.cash',
        logo: 'bchbliss.png',
        description: 'Yearly BCH builder-focused conference hosted (so far) in Ljubliana, Slovenia during May',
        socialHandles: ['t.me/bchbliss', 'twitter.com/bchbliss', 'reddit.com/user/bchbliss'],
        videos: ['https://www.youtube.com/embed/ddVj8LepAPs?si=Pip6_69zLG5MAMPN'],
        longerDescription: 'Yearly BCH builder-focused conference hosted in Ljubljana, Slovenia during May.',
        tags:[],
      },
      { 
        name: 'General Protocols',
        website: 'generalprotocols.com/',
        logo: 'generalprotocols.png',
        description: 'Building the future of programmable money. Creators of AnyHedge and BCHBull',
        socialHandles: ['t.me/GeneralProtocols','twitter.com/GeneralProtocol','www.reddit.com/user/GeneralProtocols'],
        videos: ['https://www.youtube.com/embed/707-DPzhdA8'],
        longerDescription: `Established as a company in 2019, General Protocols prides itself on developing permissionless, trustless, borderless financial solutions for the whole world. We are a leading developer in the Bitcoin Cash ecosystem and working at the frontier of UTXO blockchain development. .`,
        tags:[],
      },
      { 
        name: 'Riften Labs',
        website: 'www.riftenlabs.com/',
        logo: 'riften.jpg',
        description: 'Riften Labs invented the Cauldron Protocol, Moria Stablecoin Protocol, and the on-chain oracle d3lphi.',
        socialHandles: ['discord.gg/KnpEYfNTnv','twitter.com/RiftenLabs'],
        videos: [''],
        longerDescription: `Riften Labs is a privately owned protocol research, development, and software company. Riften Labs invented the Cauldron Protocol, Moria Stablecoin Protocol for minting of real-world assets, and the on-chain price feed oracle d3lphi. The Cauldron Protocol is a set of smart contracts that enables trading and automated liquidity provisioning`,
        tags:[],
      },
    ]
export default developmentAds